<template>
  <div class="register absolute jf-page">
    <van-nav-bar
      :title="$t('m.jf_span0')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div
      style="position:fixed;right:0px;top:0;z-index: 100; width: 40px;height: 46px;display:flex;align-items:center;"
      @click="goTo()"
    >
      <img
        class="jf-msg"
        style="width: 20px;height:20px;"
        src="../../assets/images/new/xiaoxi.png"
      />
    </div>
    <div class="content register_block" style="padding-top:1px;">
      <div
        style="height: 230px;position:absolute;left:0;top:0;width: 100%;padding-top:46px;"
      >
        <div
          style="color:#fff;font-weight:bold;font-size:16px;text-align:center;margin-top:16px;"
        >
          {{ $t("m.jf_span01") }}
        </div>
        <div
          style="color:#fff;font-weight:bold;font-size:32px;text-align:center;margin-top:8px;"
        >
          {{ dicdata.integral ? dicdata.integral : 0 }}
        </div>
        <div
          @click="jilu2"
          style="border:1px solid #fff;line-height:28px;border-radius:20px;color:#fff;font-size:13px;width: 120px;text-align:center;margin:20px auto;"
        >
          {{ $t("m.jf_span02") }}
        </div>
      </div>
      <div style="margin-top:215px;padding:0px;">
        <div
          style="border-bottom:8px solid #F5F5F8; margin-top:12px; border-radius:6px;background:#fff;height: 90px;padding:15px; display:flex;align-items:center;justify-content: space-between;"
        >
          <img
            src="../../assets/images/new/liwu.png"
            style="width: 60px;height: auto;"
            alt=""
          />
          <div style="flex:1;">
            <div style="font-size:14px;">{{ $t("m.jf_span03") }}</div>
            <div
              style="margin-top:8px; padding:0px;font-size:11px;color:#999;margin-top:6px;display:flex;align-items:center;"
            >
              {{ $t("m.jf_span04") }}
            </div>
          </div>
          <div
            @click="signIn"
            style="background:var(--bg-color); text-align:center; width:70px;line-height:26px;border-radius:20px;font-weight:bold;color:#fff;font-size:12px;"
          >
            {{ $t("m.jf_span05") }}
          </div>
        </div>
        <div style="margin-top:10px;padding:0 10px;background-color:#fff;">
          <div v-for="(items, indexs) in list" :key="indexs">
            <div
              style="height:30px; padding:0px;font-size:15px;font-weight:bold;color:var(--bg-color);display:flex;align-items:center;justify-content:center;"
            >
              <img
                src="../../assets/images/new/zuo.png"
                style="width: 18px;height: 18px;margin-right:4px"
                alt=""
              />
              <span style="margin:0 10px;">{{ items.name }}</span>
              <img
                src="../../assets/images/new/you.png"
                style="width: 18px;height: 18px;margin-right:4px"
                alt=""
              />
            </div>

            <div
              style="flex-wrap: wrap;display:flex;justify-content: space-between;margin-top:10px;"
            >
              <div
                @click="content(item.id)"
                style="width: 46%;margin:0 2%; padding:0px; background:#fff;margin-bottom:20px;border-radius:6px;overflow: hidden;"
                v-for="(item, index) in items.list"
                :key="index"
              >
                <div style="width: 90%;height: 130px;margin-left:5%;">
                  <img
                    :src="item.images"
                    style="width: 100%;height: 100%;border-radius:6px;object-fit:cover;"
                    alt=""
                  />
                </div>
                <div style="flex:1;">
                  <p
                    class="line-clamp2"
                    style="font-size:14px;font-weight:600;color:#444; margin-bottom:10px;width: 90%;margin-left:5%;margin-top:12px;"
                  >
                    {{ item.title }}
                  </p>
                  <div
                    style="height: 20px;display:flex;align-items:center;justify-content: space-between;margin-left:5%;width: 90%;"
                  >
                    <div
                      style=" display:flex;align-items:center;color:var(--bg-color);font-size:15px;font-weight:bold;"
                    >
                      <img
                        src="../../assets/images/new/fenji.png"
                        style="width: 15px;height: 15px;margin-right:4px;"
                        alt=""
                      />
         
                     {{ parseInt(item.price, 10) }}
                    </div>

                    <span style="color:#999;font-size:11px;"
                      >{{ item.num }}{{ $t("m.jf_span4") }}</span
                    >
                  </div>
                  <div
                    style="margin-left:5%; background-color:var(--bg-color);line-height:28px;border-radius:20px;color:#fff;font-size:14px;font-weight:bold;width: 100px;margin-top:8px; text-align:center;"
                  >
                    {{ $t("m.jf_span9") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 70px;"></div>
  </div>
</template>

<script>
import request from "@utils/request";
import { goodsImage } from "@utils/goodsImage";

export default {
  name: "JfList",
  data: function() {
    return {
      money: "",
      mima: "",
      dicdata: {},
      list: []
    };
  },

  mounted: function() {
    request
      .get("/shop/goods/cat", {}, { login: false })
      .then(res => {
        console.log(res);
        // let list = []
        // for (let index = 0; index < res.data.data.length; index++) {
        //   let arr = res.data.data[index].list;
        //   for (let j = 0; j < arr.length; j++) {
        //     const cs = arr[j];
        //     list.push(cs)
        //   }
        // }
        const cats = (res && res.data && res.data.data) || [];
        this.list = cats.map(cat => {
          const goods = (cat.list || []).map(item => {
            return Object.assign({}, item, {
              images: goodsImage(item.images || item.image)
            });
          });
          return Object.assign({}, cat, { list: goods });
        });
      })
      .catch(err => {
        this.$dialog.error(err.response.data.msg);
      });
    let that = this;
    setTimeout(function() {
      request
        .post("/user/user/index", {}, { login: true })
        .then(res => {
          console.log("积分");
          console.log(res);
          that.dicdata = res.data.data;
        })
        .catch(err => {
          that.$dialog.error(err.response.data.msg);
        });
    }, 1000);
  },
  methods: {
    jilu1() {
      this.$router.push({
        path: "/Signln"
      });
    },
    jilu2() {
      this.$router.push({
        path: "/dhlist"
      });
    },
    goTo() {
      this.$router.push({
        path: "/article"
      });
    },
    signIn() {
      this.$router.push({
        path: "/Signln"
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    chakan() {
      this.$router.push({
        path: "*"
      });
    },
    content(e) {
      this.$router.push({
        path: "/JfContent/" + e
      });
    }
  }
};
</script>
<style scoped lang="less">
.jf-page {
  min-height: 100vh;
  background-color: #fff;
  background-image: url(../../assets/images/new/mod3-gradient-bg.png);
  background-repeat: no-repeat;
  background-size: 100% 280px;
}
.jf-msg {
  filter: brightness(0) invert(1);
}
/deep/ .van-hairline--bottom::after {
  border-bottom-width: 0px;
}
/deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: transparent;
  border: 0px solid;
}
/deep/ .van-nav-bar__title {
  color: #fff;
}
/deep/ .van-icon {
  color: #fff;
}
.content {
  font-weight: bold;
  color: #000;
  background: transparent;
  position: relative;
}
.contents {
}
.line-clamp2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.register_block {
}
.register_tit {
  background: rgb(242, 2, 2);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  color: #fff;
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
</style>
